import { Injectable } from '@angular/core';
const publicConfig = process.env.PUBLIC_CONFIG;

@Injectable()
export class PortalConfig {
  get publicConfig(): any {
    return publicConfig;
  }
}
